<template>
    <div @click="setAcl" class="acl-button">
        <span v-if="internalValue == null" class="null"><i class="icon icon-icon_refresh"></i></span>
        <span v-if="internalValue == true" class="true"><i class="icon icon-check"></i></span>
        <span v-if="internalValue == false" class="false"><i class="icon icon-blocked"></i></span>
    </div>
</template>

<script>
    export default {
        name: 'Active',
        props: ['value'],
        data: function () {
            return {
                internalValue: ''
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
            setAcl: function()
            {
                if( this.internalValue == null ){
                    this.internalValue = true;
                }else if( this.internalValue == true ){
                    this.internalValue = false;
                }else{
                    this.internalValue = null;
                }
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Acl.vue